import apiClient from "../api/apiClient";
import ENDPOINTS from "../api/endPoint";


// Get all customers for promotion mailing
export const fetchAllCustomers = async () => {
  const response = await apiClient(ENDPOINTS.GET_ALL_CUSTOMERS, {
    method: "GET",
  });

  // Normalize and return mapped data
  if (response?.data) {
    return response.data.map((item) => ({
      id: item.customer_Id,
      name: item.customer_Name,
      accountName: item.accountName,
      email: item.mail,
    }));
  }

  return [];
};

export const promotionService = {
  sendPromotionEmail: (file, id) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("customers", JSON.stringify(id)); // send as JSON string

    return apiClient(ENDPOINTS.PROMOTION.SEND_EMAIL, {
      method: "POST",
      body: formData,
      requiresAuth: true, // assuming your apiClient handles token headers
    });
  },
};

export const fetchPromotionFiles = () => {
  return apiClient(ENDPOINTS.PROMOTION.FETCH, {
    method: "GET",
  });
};
